import React, { useEffect, useRef } from "react";
import { Box, CircularProgress } from "@mui/material";

// Infinite-scroll sentinel: loads the next page itself once it scrolls into
// view, instead of waiting for a tap — matches how a guest actually browses a
// menu on their own phone.
export default function AutoLoadMore({ hasMore, loadingMore, onLoadMore }) {
  const sentinelRef = useRef(null);
  const loadingRef = useRef(loadingMore);
  loadingRef.current = loadingMore;

  useEffect(() => {
    if (!hasMore) return;
    const el = sentinelRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !loadingRef.current) onLoadMore();
      },
      { rootMargin: "200px" }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [hasMore, onLoadMore]);

  if (!hasMore) return null;
  return (
    <Box ref={sentinelRef} sx={{ display: "flex", justifyContent: "center", py: 2, minHeight: 40 }}>
      {loadingMore && <CircularProgress size={20} />}
    </Box>
  );
}
